<match-display-wrapper
    matchLabel="{{ l10nKeys.ldapGroupLabel | vtranslate }}"
    matchCriteria="{{ matchCriteria }}"
>
    <div *ngFor="let group of groups; trackBy: trackByIndex">
        {{ group }}
    </div>
</match-display-wrapper>
